import styled from "styled-components";

export const OfoWidgetContainer = styled.div`
    height: auto;
    padding: 0 0 ${(props) => props.theme.spacing.medium};
`;

export const MarginBottomDiv = styled.div`
    height: ${(props) => props.theme.spacing.xLarge};
`;

export const ObserverNoWidthStyles: React.CSSProperties = {
    width: "0px",
    height: "0px",
};

export const CornerWrapper = styled.div<{ $isRight?: boolean }>(({ theme, $isRight }) => ({
    position: "fixed",
    background: theme.colors[theme.colorMode].primary,
    ...($isRight && { right: 0 }),
}));

export const RadialElement = styled.div<{ $isLeft?: boolean; $isRight?: boolean }>(({ theme, $isLeft, $isRight }) => ({
    height: theme.spacing.large,
    width: theme.cornerRadius.medium,
    ...($isLeft && { borderTopLeftRadius: theme.cornerRadius.xxLarge }),
    ...($isRight && { borderTopRightRadius: theme.cornerRadius.xxLarge }),
    background: theme.colors[theme.colorMode].background_Secondary,
}));
